import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

import { formatNow } from '@/helpers/formatDate'

export default {
  namespaced: true,
  state () {
    return {
      addFile: {
        creation: formatNow(),
        type: '4',
        description: undefined,
        file: null,
        name: null,
        base: null,
        size: null
      },
      isThereFiles: false,
      list: [],
      _: {},
      toDeleteList: []
    }
  },
  mutations,
  actions,
  getters
}
